const closeBannerButton = document.querySelector(".close-banner");
const bannerContactFixed = document.querySelector(".banner-contact-fixed");

closeBannerButton.addEventListener("click", function () {
  event.preventDefault();
  bannerContactFixed.classList.toggle("close-active");
});
